/**
 * Characters splitting a pasted list into search tags (multiselect search).
 * The space is left out: brand or holding labels contain spaces.
 */
export const DEFAULT_SEARCH_TAG_SEPARATORS = [';', ',', '\n', '\t', '\r'];

/**
 * Separators per filter definition name, when they differ from the default ones.
 * Product codes never contain spaces, so a list of codes separated by spaces is split too.
 */
export const SEARCH_TAG_SEPARATORS_BY_FIELD: Partial<Record<string, string[]>> = {
  ean: [...DEFAULT_SEARCH_TAG_SEPARATORS, ' '],
  item: [...DEFAULT_SEARCH_TAG_SEPARATORS, ' ']
};
